var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKongtiao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mynaui:air-conditioner-solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53309 10.1983C5.41474 10.0713 5.25422 10 5.08684 10C4.91946 10 4.75894 10.0722 4.64058 10.1992C4.52223 10.3261 4.45574 10.4983 4.45574 10.6778C4.45574 11.2699 4.43049 11.7915 4.29165 12.1579C4.22854 12.3258 4.15365 12.4251 4.07455 12.4856C3.99882 12.5433 3.86924 12.6038 3.6311 12.6038C3.46372 12.6038 3.3032 12.6751 3.18485 12.8021C3.06649 12.929 3 13.1012 3 13.2807C3 13.4602 3.06649 13.6324 3.18485 13.7593C3.3032 13.8863 3.46372 13.9576 3.6311 13.9576C4.08297 13.9576 4.48014 13.8375 4.80663 13.5875C5.10284 13.3546 5.33013 13.035 5.46129 12.667C5.70616 12.0217 5.71794 11.241 5.71794 10.6769C5.71794 10.4974 5.65145 10.3252 5.53309 10.1983Z",
    fill: "#37BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44626 10.1992C8.3279 10.0722 8.16738 10.0009 8 10.0009C7.83262 10.0009 7.6721 10.0722 7.55375 10.1992C7.43539 10.3261 7.3689 10.4983 7.3689 10.6778V14.3231C7.3689 14.5026 7.43539 14.6748 7.55375 14.8017C7.6721 14.9287 7.83262 15 8 15C8.16738 15 8.3279 14.9287 8.44626 14.8017C8.56461 14.6748 8.6311 14.5026 8.6311 14.3231V10.6778C8.6311 10.4983 8.56461 10.3261 8.44626 10.1992Z",
    fill: "#37BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3586 10.1992C11.2402 10.0722 11.0797 10.0009 10.9123 10.0009C10.7449 10.0009 10.5844 10.0722 10.4661 10.1992C10.3477 10.3261 10.2812 10.4983 10.2812 10.6778C10.2812 11.2419 10.2947 12.0226 10.5387 12.6679C10.6699 13.0359 10.8972 13.3555 11.1934 13.5884C11.519 13.8384 11.917 13.9585 12.3689 13.9585C12.5363 13.9585 12.6968 13.8872 12.8152 13.7602C12.9335 13.6333 13 13.4611 13 13.2816C13 13.1021 12.9335 12.9299 12.8152 12.803C12.6968 12.676 12.5363 12.6047 12.3689 12.6047C12.1308 12.6047 12.0012 12.5442 11.9254 12.4865C11.8463 12.426 11.7715 12.3267 11.7083 12.1588C11.5687 11.7924 11.5434 11.2708 11.5434 10.6778C11.5434 10.4983 11.4769 10.3261 11.3586 10.1992Z",
    fill: "#37BCFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630130",
    x: 0.5,
    y: 2.5,
    width: 15,
    height: 6,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630131",
    x: 2,
    y: 6,
    width: 12,
    height: 2,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKongtiao);
export default __webpack_public_path__ + "static/media/kongtiao.1355745d3a193eb845f25aec3a90a6c7.svg";
export { ForwardRef as ReactComponent };